import { createSlice, PayloadAction } from "redux-starter-kit";
import { LoadingState } from "../../http";
import { TeamDtoWithBreadcrumb } from "./SubHeaderDto";

export interface GetSubheaderDetailFetchPayload {
  id: string;
}

export interface SerializedError {
  message: string;
  status?: number;
  statusText?: string;
}

export interface SubheaderState {
  loadingState: LoadingState;
  subheaderDetail: TeamDtoWithBreadcrumb | undefined;
  errorCode?: number;
}

const initialState: SubheaderState = {
  loadingState: LoadingState.NO_DATA,
  subheaderDetail: undefined,
};

const subheaderSlice = createSlice({
  slice: "subheader",
  initialState,
  reducers: {
    getSubheaderDetailFetch: (
      state,
      _action: PayloadAction<GetSubheaderDetailFetchPayload>
    ) => {
      state.loadingState = LoadingState.LOADING;
      state.errorCode = undefined;
    },
    getSubheaderDetailFetchCancel: (state) => {
      state.loadingState = LoadingState.NO_DATA;
    },
    getSubheaderDetailFetchRejected: (state, action) => {
      state.loadingState = LoadingState.REJECTED;
      const error = action.payload as SerializedError;
      if (error.status) state.errorCode = error.status;
      console.error(action.type, error.message || "Unknown error");
    },
    getSubheaderDetailFetchSuccess: (state, action) => {
      state.errorCode = undefined;
      state.loadingState = LoadingState.RESOLVED;
      state.subheaderDetail = action.payload.data;
    },
  },
});

export default subheaderSlice;
